export default __webpack_public_path__ + "ff45129e04a4ffeb1773db33abdc25f0.jpg";